// App.js
import { Routes, Route } from "react-router-dom";
// Import Helmet for global default title
import { Helmet } from "react-helmet"; 
// Remove unused useEffect import
// import { useEffect } from "react"; 

import Home from "./Pages/Home";
import ServicesPage from "./Pages/Services";
import AboutUsPage from "./Pages/About";
import PricingPage from "./Pages/Pricing";
import LegalPage from "./Pages/Legal";
import ContactPage from "./Pages/Contact";
import LoginPage from "./Pages/Login";
import LegalDetailPage from "./Pages/LegalDetail";
import TermsOfService from "./Pages/Termsofservice";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

const App = () => {
  /* Removed the old useEffect logic:
  useEffect(() => {
    document.title = "Steminorder";
  }, []);
  
  The Helmet component below achieves the same goal declaratively.
  */
  
  return (
    <>
      {/* This Helmet sets the GLOBAL FALLBACK title. 
        It will be overwritten by any Helmet component inside a specific page component.
      */}
      <Helmet>
        <title>Steminorder - Global Maritime Platform</title>
        <meta name="robots" content="index, follow" /> {/* General site indexing instruction */}
      </Helmet>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/legal-assistance" element={<LegalPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/legal-detail" element={<LegalDetailPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
};

export default App;